<template>
  <div class="crewHome">
    <div
      class="crewHome-content"
      style="overflow-y: scroll; position: relative"
    >
      <el-form
        style="margin-top: 20px"
        label-position="top"
        :model="jobUser"
        :rules="rules"
        ref="jobUser"
        class="other-job-form"
      >
        <el-form-item label="职位所属公司" prop="clientCompanyId">
          <el-select
            v-model="jobUser.clientCompanyId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入职位所属公司"
            :remote-method="remoteMethod"
            :disabled="editVisible"
          >
            <el-option
              v-for="item in companyList"
              :key="item.COMPANY_ID"
              :label="item.company_name"
              :value="item.COMPANY_ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="船舶航区" prop="naviAreaCode">
          <el-select
            v-model="jobUser.naviAreaCode"
            placeholder="请选择船舶航区"
            @change="changeJobPlace(jobUser.naviAreaCode)"
            :disabled="editVisible"
          >
            <el-option
              v-for="item in dictList"
              :key="item.code"
              :label="item.itemNameCn"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位名称" prop="positionCode">
          <el-select
            v-model="jobUser.positionCode"
            filterable
            placeholder="请选择职位名称"
            :disabled="editVisible"
          >
            <el-option-group
              v-for="group in jobOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.compDutiesCode"
                :label="item.compDutiesName"
                :value="item.compDutiesCode"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="证书等级" prop="certLevelCode">
          <el-select
            v-model="jobUser.certLevelCode"
            placeholder="请选择证书等级"
            :disabled="editVisible"
          >
            <el-option
              v-for="item in certList"
              :key="item.code"
              :label="item.itemNameCnShort"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="船舶年龄" prop="shipAge">
          <el-input
            v-model="jobUser.shipAge"
            placeholder="请输入船舶年龄"
            class="other-append"
            :disabled="editVisible"
          >
            <template #append>年</template></el-input
          >
        </el-form-item>
        <el-form-item label="船舶种类" prop="shipTypeCode">
          <el-select
            v-model="jobUser.shipTypeCode"
            placeholder="请选择船舶类型"
            :disabled="editVisible"
          >
            <el-option
              v-for="val in shipTypeList"
              :key="val.typeId"
              :label="val.shiptypeNameCn"
              :value="val.typeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="船舶总吨" prop="recuritShipTon">
          <el-input
            v-model="jobUser.recuritShipTon"
            placeholder="请输入船舶总吨"
            :disabled="editVisible"
          ></el-input>
        </el-form-item>
        <el-form-item label="船舶经验" prop="workingYearEnd">
          <el-input
            v-model="jobUser.workingYearEnd"
            placeholder="请输入船舶经验"
            class="other-append"
            :disabled="editVisible"
          >
            <template #append>年</template></el-input
          >
        </el-form-item>
        <el-form-item label="招聘人数" prop="jobNum">
          <el-input
            v-model="jobUser.jobNum"
            placeholder="请输入招聘人数"
            class="other-append"
            :disabled="editVisible"
          >
            <template #append>人</template></el-input
          >
        </el-form-item>
        <el-form-item label="职位月薪" :prop="salaryFace">
          <el-col :span="8">
            <el-form-item style="width: 100%" class="other-append">
              <el-input
                type="text"
                v-model="jobUser.salaryBegin"
                :disabled="editVisible || isFace"
              >
                <template #append>元</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="text-align: center">-</el-col>
          <el-col :span="8">
            <el-form-item style="width: 100%" class="other-append">
              <el-input
                type="text"
                v-model="jobUser.salaryEnd"
                :disabled="editVisible || isFace"
              >
                <template #append>元</template></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-left: 10px"
            ><el-checkbox
              v-model="isFace"
              :disabled="editVisible"
              @change="changeFace(isFace)"
              >面议</el-checkbox
            ></el-col
          >
        </el-form-item>
        <el-form-item label="登船地点" prop="locationProvinceCode">
          <el-col :span="11">
            <el-form-item style="width: 100%">
              <el-select
                v-model="jobUser.locationProvinceCode"
                placeholder="请选择省份"
                @change="city()"
                :disabled="editVisible"
              >
                <el-option
                  v-for="val in porList"
                  :key="val.code"
                  :label="val.name"
                  :value="val.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="text-align: center">-</el-col>
          <el-col :span="11">
            <el-form-item style="width: 100%">
              <el-select
                v-model="jobUser.locationPortCode"
                placeholder="请选择市"
                @change="getPortName()"
                :disabled="editVisible"
              >
                <el-option
                  v-for="val in cityList"
                  :key="val.code"
                  :label="val.itemNameCn"
                  :value="val.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="最低学历" prop="education">
          <el-select
            v-model="jobUser.education"
            placeholder="请选择最低学历"
            :disabled="editVisible"
          >
            <el-option
              v-for="val in crewEduList"
              :key="val.code"
              :label="val.itemNameCn"
              :value="val.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同时长" prop="contractDuration">
          <el-input
            v-model="jobUser.contractDuration"
            placeholder="请输入合同时长"
            class="other-append"
            :disabled="editVisible"
          >
            <template #append>年</template></el-input
          >
        </el-form-item>
        <el-form-item label="职位福利" class="other-welfare">
          <el-checkbox-group
            v-model="welfList"
            @change="changeWelf()"
            :disabled="editVisible"
          >
            <el-checkbox
              :label="item"
              v-for="(item, index) in welfareList"
              :key="index"
            ></el-checkbox>
          </el-checkbox-group>
          <input
            type="text"
            class="form-item"
            name="tagModel"
            v-model="tagModel"
            v-if="!editVisible"
          />
          <div class="bgblue" @click="addWelf()" v-if="!editVisible">添加</div>
        </el-form-item>
      </el-form>
      <div class="other-job-remark">职位说明</div>
      <div class="other-job-textarea">
        <el-input
          type="textarea"
          placeholder="请输入职位说明"
          v-model="jobUser.jobDesc"
          resize="none"
          :disabled="editVisible"
        >
        </el-input>
      </div>
      <div class="other-job-footer">
        <el-button
          v-if="!editVisible"
          type="primary"
          style="background: #1a65e2"
          @click="saveJob()"
          >保存</el-button
        >
        <!-- <el-button
          v-if="editVisible"
          type="primary"
          style="background: #1a65e2"
          @click="editJob()"
          >编辑</el-button
        > -->
        <el-button @click="gotoBack()">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCompanyNameBykeyword,
  getDutyList,
  getSrzCertLevelCode,
  selectRecruitDictInfo,
  selectShipLocationPortList,
  saveOrPublishJob,
  viewJobInfoByJobId,
} from "@/apis/index";

export default {
  data() {
    return {
      jobUser: {
        status: "1",
        welfareTag: "[]",
        jobDesc: "",
      },
      rules: {
        clientCompanyId: [
          { required: true, message: "请选择公司", trigger: "blur" },
        ],
        naviAreaCode: [
          { required: true, message: "请选择船舶航区", trigger: "blur" },
        ],
        positionCode: [
          { required: true, message: "请选择职位名称", trigger: "blur" },
        ],
        certLevelCode: [
          { required: true, message: "请选择证书等级", trigger: "blur" },
        ],
        shipAge: [
          { required: true, message: "请输入船舶年龄", trigger: "blur" },
          { validator: this.validateNumber, trigger: "blur" },
        ],
        shipTypeCode: [
          { required: true, message: "请选择船舶类型", trigger: "blur" },
        ],
        recuritShipTon: [
          { required: true, message: "请输入船舶总吨", trigger: "blur" },
          { validator: this.validateNumber, trigger: "blur" },
        ],
        workingYearEnd: [
          { required: true, message: "请输入船舶经验", trigger: "blur" },
          { validator: this.validateNumber, trigger: "blur" },
        ],
        jobNum: [
          { required: true, message: "请输入招聘人数", trigger: "blur" },
          { validator: this.validateNumber, trigger: "blur" },
        ],
        salaryBegin: [
          { required: true, message: "请输入职位月薪", trigger: "blur" },
          { validator: this.validateNumber, trigger: "blur" },
        ],
        locationProvinceCode: [
          { required: true, message: "请选择登船地点", trigger: "blur" },
        ],
        education: [
          { required: true, message: "请选择最低学历", trigger: "blur" },
        ],
        contractDuration: [
          { required: true, message: "请输入合同时长", trigger: "blur" },
        ],
      },
      salaryFace: "salaryBegin",
      keyword: "",
      companyList: [],
      dictList: [
        {
          code: "2",
          itemNameCn: "沿海航区",
        },
        {
          code: "4",
          itemNameCn: "无限航区",
        },
        {
          code: "N",
          itemNameCn: "内河",
        },
        {
          code: "D",
          itemNameCn: "东南亚航区",
        },
      ],
      jobOptions: [
        {
          label: "其他",
          options: [],
        },
        {
          label: "轮机",
          options: [],
        },
        {
          label: "通信",
          options: [],
        },
        {
          label: "驾驶",
          options: [],
        },
      ],
      certList: [],
      shipTypeList: [],
      crewEduList: [],
      porList: [],
      cityList: [],
      welfareList: [
        "五险一金",
        "节日福利",
        "全勤奖",
        "包吃包住",
        "补充医疗保险",
        "年底双薪",
        "绩效奖金",
        "年终分红",
      ],
      welfList: [],
      tagModel: "",
      loading: false,
      options: [],
      editVisible: false,
      isFace: false,
    };
  },
  mounted() {
    this.selectShipLocationPortLists();
    this.getCompanyNameBykeywordList();
    this.getSrzCertLevelCodeList();
    this.selectRecruitDictInfoList();

    if (
      this.$route.params.editVisible == true &&
      !this.$route.params.progressVisible
    ) {
      this.editVisible = true;
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.getUser();
        // console.log(val); //新路由信息
        // console.log(oldval); //老路由信息
        switch (val.fullPath) {
          case "/maritimeColumn":
            this.hoverIndex = 3;
            break;
          case "/healthView":
            this.hoverIndex = 4;
            break;
          case "/crewProblem":
            this.hoverIndex = 5;

            break;
          case "/shipInformation":
            this.hoverIndex = 6;
            break;
          case "/aboutUs":
            this.hoverIndex = 7;
            break;
          case "/maritimeDeclaration":
            this.hoverIndex = 3;
            break;
          default:
            this.hoverIndex = 0;
            break;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    //数字
    validateNumber(rule, value, callback) {
      const regex = /^\d+$/;
      if (!value || regex.test(value)) {
        // 验证通过
        callback();
      } else {
        // 验证未通过，传入错误信息
        callback(new Error("请输入数字"));
      }
    },
    //证书等级
    async getSrzCertLevelCodeList() {
      const res = await getSrzCertLevelCode();
      // console.log(res);
      this.certList = res.data;
    },
    async getDutyListList(type, el) {
      if (el == "edit") {
        console.log();
      } else {
        this.$set(this.jobUser, "positionCode", "");
      }

      const res = await getDutyList({ naviArea: type });
      this.jobOptions[0].options = res.data["其他"] || "";
      this.jobOptions[1].options = res.data["轮机"] || "";
      this.jobOptions[2].options = res.data["通信"] || "";
      this.jobOptions[3].options = res.data["驾驶"] || "";
      // this.companyList = res.data;
    },
    //船舶种类
    async selectRecruitDictInfoList() {
      const res = await selectRecruitDictInfo();
      this.shipTypeList = res.data.cbShipParentTypeList;
      this.crewEduList = res.data.crewEducationList;
    },
    //登船地点
    async selectShipLocationPortLists() {
      const res = await selectShipLocationPortList();
      // console.log(res);
      this.porList = res.data;
      if (
        this.$route.params.editVisible == true ||
        this.$route.params.progressVisible
      ) {
        this.viewJobInfoByJobIdList();
      }
    },
    city() {
      if (!this.jobUser.locationProvinceCode) {
        this.cityList = [];
        // console.log("122");
      } else {
        // console.log("211");
        this.porList.forEach((item) => {
          if (this.jobUser.locationProvinceCode == item.code) {
            this.cityList = item.chirld;
            this.jobUser.locationProvinceName = item.name;
          }
        });
        // console.log(this.porList);
        // console.log(this.cityList);
      }
    },
    getPortName() {
      this.cityList.forEach((item) => {
        if (this.jobUser.locationPortCode == item.code) {
          this.jobUser.locationPortName = item.itemNameCn;
        }
      });
    },
    changeJobPlace(type) {
      this.getDutyListList(type);
    },
    changeWelf() {
      // console.log(this.welfList);
      //  JSON.parse($scope.params.welfareTag);
      this.jobUser.welfareTag = JSON.stringify(this.welfList);
    },
    addWelf() {
      if (this.welfareList.indexOf(this.tagModel) > -1) {
        this.$message({
          message: "标签已经存在",
          type: "warning",
        });
        return;
      }
      this.welfareList.push(this.tagModel);
      this.tagModel = "";
    },
    //sumbit
    async save() {
      // try {
      // if (this.jobUser.companyId) {
      //   this.jobUser.clientCompanyId = this.jobUser.companyId;
      // }

      const res = await saveOrPublishJob(this.jobUser);
      // console.log(res);
      if (res.code == 1) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.$router.push({ name: "招聘中" });
      }
    },
    saveJob() {
      this.$refs.jobUser.validate((valid) => {
        if (valid) {
          this.save();
          // 表单验证通过，执行提交逻辑
          // ...
        } else {
          // 表单验证未通过
        }
      });
    },
    gotoBack() {
      this.$router.go(-1);
    },
    remoteMethod(query) {
      this.keyword = query;
      this.getCompanyNameBykeywordList();
    },
    //职位
    async getCompanyNameBykeywordList() {
      const res = await getCompanyNameBykeyword({ keyword: this.keyword });
      // console.log(res);
      this.companyList = res.data;
    },
    //详情
    async viewJobInfoByJobIdList() {
      const res = await viewJobInfoByJobId({ jobId: this.$route.params.jobId });
      this.jobUser = { ...res.data, status: "1" };
      this.$set(this.jobUser, "clientCompanyId", res.data.clientCompanyName);
      // this.jobUser.clientCompanyId = res.data.companyId;
      this.welfList = JSON.parse(res.data.welfareTag);
      // console.log(this.welfList);
      let arr = this.getUniqueValues(
        JSON.parse(res.data.welfareTag),
        this.welfareList
      );
      // console.log(arr);
      this.welfareList = this.welfareList.concat(arr);
      if (res.data.isFace == 1) {
        this.isFace = true;
      }
      this.getDutyListList(this.jobUser.naviAreaCode, "edit");
      this.city();
    },
    getUniqueValues(arr1, arr2) {
      // console.log(arr1, arr2);
      return arr1.filter((item) => !arr2.includes(item));
    },
    editJob() {
      this.editVisible = false;
    },
    changeFace(item) {
      if (item == true) {
        this.jobUser.isFace = 1;
        this.$set(this.jobUser, "salaryBegin", "");
        this.$set(this.jobUser, "salaryEnd", "");
        this.salaryFace = "";
      } else {
        this.jobUser.isFace = 0;
        this.salaryFace = "salaryBegin";
      }
    },
    // this.$route.params
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
